<template>
    <Title_Base :icon="icon" :title="text">
    </Title_Base>
</template>


<script>
import Title_Base from "@/components/SingleUse/ComponentOverrides/pagetitle/Title_Base.vue";
import ContractMixin from "@/helpers/Mixins/ContractMixin";

export default {
    name: 'Title_ContractLists',
    props: {},
    components: {
        Title_Base,
    },
    mixins: [ContractMixin],

    data() {
        return {
        };
    },

    methods: {},

    computed: {
        typeId() {
            return this.$route.params.contractTypeId;
        },

        icon() {
            return this.getContractTypeIcon(this.typeId); //from mixin
        },

        text() {
            if (this.loading) {
                return this.$t('servicesystem.common_objects.fallbackterms.loading');
            }
            else {
                return this.getContractTypeName(this.typeId); //from mixin
            }
        },

        loading() {
            return this.ContractTypesLoading; //from mixin
        },
    },

    watch: {},
};
</script>


<style lang='scss' scoped></style>